function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M56.9105,106.0832a50.141,50.141,0,1,1,50.3057-49.9818A49.94,49.94,0,0,1,56.9105,106.0832ZM56.7954,99c23.3266,1.32,43.4164-20.0924,43.6-42.6505.1919-23.5489-20.4355-43.4808-42.7865-43.7289-23.5673-.2616-43.7911,20.397-43.8569,43.1651C13.6852,79.021,34.14,100.0887,56.7954,99Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.5315,64.8915q8.4863-.0018,16.9724-.0045c2.5682-.0048,4.6972.4249,4.5883,3.7517-.1009,3.081-2.2077,3.3289-4.5012,3.3314q-17.4715.0185-34.9431.01c-2.5654.0015-4.6986-.4251-4.5879-3.7539.1023-3.08,2.2052-3.3236,4.5008-3.329C45.551,64.8832,51.5413,64.8926,57.5315,64.8915Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.847,40.5276a6.7063,6.7063,0,0,1-5.8965,6.1039c-2.9791.4932-6.7387-2.9678-6.6556-6.1165.0964-3.6526,2.1736-5.8824,5.8015-6.3394C44.318,33.77,47.7036,36.915,47.847,40.5276Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.91,40.3575c-.0313,3.112-3.566,6.6991-6.5524,6.2858a6.4562,6.4562,0,0,1-5.9987-6.3017c-.2328-3.1767,3.3391-6.3655,6.543-6.2111A6.557,6.557,0,0,1,78.91,40.3575Z",
  fill: "currentColor"
}));

var SvgEmoticonLow = function SvgEmoticonLow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113.3858 113.3858",
    width: 40,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoticonLow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoticon_low.fa7f7ffb.svg";
export { ForwardRef as ReactComponent };